import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { Button, Text, FlexBox } from '@eltoro-ui/components';
import { formatPriceRange } from 'Pages/Orderlines/helpers';
import './FindYourProspectFilters.scss';

export type SelectOptionType = {
  label: string;
  value: string;
};

type TT = {
  bedNBath: boolean;
  price: boolean;
  squareFoot: boolean;
  homeType: boolean;
};

export const PriceFilter = ({
  modalOpen,
  setIsModalOpen,
  setPrice,
  currentFilters,
  postedFilters,
  setPostedFilter,
  setIsClicked,
  isClicked,
}: {
  modalOpen: any;
  setIsModalOpen: any;
  // setIsModalOpen: (price: boolean) => void
  setPrice: any;
  currentFilters: any;
  postedFilters: any;
  setPostedFilter: any;
  setIsClicked?: any;
  isClicked?: any;
}) => {
  const dropdownRef = useRef<Dropdown | null>(null);
  const [isDisabled, setIsDisabled] = useState(true);
  const [selectedRange, setSelectedRange] = useState('');
  const [customMin, setCustomMin] = useState('');
  const [customMax, setCustomMax] = useState('');
  const [customRange, setCustomRange] = useState(currentFilters.price);
  const [error, setError] = useState('');
  const [isOptionSelected, setIsOptionSelected] = useState('');

  const arrOfPrice: SelectOptionType[] = [
    { label: 'Any price range', value: 'Any' },
    { label: '$0 - $99,000', value: '0 - 99000' },
    { label: '$100,000 - $199,000', value: '100000 - 199000' },
    { label: '$200,000 - $299,000', value: '200000 - 299000' },
    { label: '$300,000 - $399,000', value: '300000 - 399000' },
    { label: '$400,000 - $499,000', value: '400000 - 499000' },
    { label: '$500,000 - $599,000', value: '500000 - 599000' },
    { label: '$600,000 - $699,000', value: '600000 - 699000' },
    { label: '$700,000 - $799,000', value: '700000 - 799000' },
    { label: '$800,000 - $899,000', value: '800000 - 899000' },
    { label: '$900,000 - $999,000', value: '900000 - 999000' },
    { label: '$1,000,000 - $1,499,000', value: '1000000 - 1499000' },
    { label: '$1,500,000 - $1,999,000', value: '1500000 - 1999000' },
    { label: '$2,000,000 - $2,999,000', value: '2000000 - 2999000' },
    { label: '$3,000,000 - $3,999,000', value: '3000000 - 3999000' },
    { label: '$4,000,000 - $4,999,000', value: '4000000 - 4999000' },
    { label: '$6,000,000 - $6,999,000', value: '6000000 - 6999000' },
    { label: 'Custom price range', value: 'Custom price range' },
  ];

  useEffect(() => {
    if (currentFilters.price) {
      const findPriceInPriceList = arrOfPrice.find(opt => opt.value === currentFilters.price);
      if (!findPriceInPriceList) {
        const customRanges = currentFilters.price?.split('-');
        setCustomMin(customRanges?.[0] ?? '');
        setCustomMax(customRanges?.[1] ?? '');
        setIsOptionSelected('Custom price range');
      } else {
        setIsOptionSelected(currentFilters.price);
      }
    }
  }, []);
  const cancelDefaultActions = (
    e: React.MouseEvent<Element> | React.ChangeEvent<Element> | DropdownChangeEvent
  ) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const handleCustomInputChange = (value: string, type: 'min' | 'max') => {
    let numericValue = value.replace(/\D/g, '');
    if (numericValue !== '0') {
      numericValue = numericValue.replace(/^0+/, '');
    }
    if (type === 'min') {
      setCustomMin(numericValue);
    } else {
      setCustomMax(numericValue);
    }
  };
  const validateCustomRange = (min: string, max: string) => {
    const minNum = parseInt(min || '0', 10);
    const maxNum = parseInt(max || '0', 10);
    const trimmedMin = min.trim();
    if (!trimmedMin && maxNum) {
      setCustomMin('0');
    }
    if (!trimmedMin && !max.trim()) {
      setError('Both fields are required');
    } else if (maxNum === 0) {
      setError('Max should be greater than zero.');
    } else if (min && max && minNum > maxNum) {
      setError('Min should be lower than Max.');
    } else {
      setError('');
      const range = `${minNum} - ${maxNum}`;
      setSelectedRange(range);
      setCustomRange(range);
      if (dropdownRef.current) {
        dropdownRef.current.hide();
      }
    }
  };

  const onChange = (e: DropdownChangeEvent | React.MouseEvent, value: string) => {
    if (value === 'Custom price range') {
      cancelDefaultActions(e);
    }
    setIsOptionSelected(value);
    setSelectedRange(value);
  };
  const onClickCancelOrClear = (type: string) => {
    setIsModalOpen({ ...modalOpen, price: false });
    if (type === 'Clear') {
      setPostedFilter({
        ...postedFilters,
        price: null,
      });
      setPrice({
        ...currentFilters,
        price: null,
      });

      if (selectedRange || currentFilters?.price) {
        setIsClicked({ ...isClicked, isLoaded: false });
      }
    }
    // show prospects box on cancel
    // else {
    //   setIsClicked({ ...isClicked, isLoaded: true })
    // }
  };

  const onSaveChanges = () => {
    const isCustomSelected = selectedRange === 'Custom price range';
    const selectedPrice = isCustomSelected ? customRange : selectedRange;

    const finalPrice =
      selectedPrice || // user’s new choice
      currentFilters?.price || // previously applied filter
      null;

    setIsModalOpen({ ...modalOpen, price: false });
    setIsClicked({ ...isClicked, isLoaded: false });

    setPostedFilter({
      ...postedFilters,
      price: finalPrice,
    });

    setPrice({
      ...currentFilters,
      price: finalPrice,
    });
  };
  useEffect(() => {
    if (selectedRange || currentFilters?.price) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [selectedRange, currentFilters]);

  const itemTemplate = (option: SelectOptionType) => {
    const isCustomRange = option.label === 'Custom price range';

    const handleOptionClick = (e: React.MouseEvent) => {
      if (option.label === 'Custom price range') {
        cancelDefaultActions(e);
      } else {
        const findPriceInPriceList = arrOfPrice.find(opt => opt.value === currentFilters.price);
        if (findPriceInPriceList) {
          setCustomMin('');
          setCustomMax('');
          setCustomRange('');
          setError('');
        } else {
          const customRanges = currentFilters.price?.split('-');
          setCustomMin(customRanges?.[0] ?? '');
          setCustomMax(customRanges?.[1] ?? '');
          setCustomRange(currentFilters.price);
          setError('');
        }
      }
      onChange(e, option.value);
    };
    const handleApply = () => {
      validateCustomRange(customMin, customMax);
    };
    return (
      <button
        className={classnames('selection-wrapper', {
          'custom-select':
            isOptionSelected === 'Custom price range' && option.value === 'Custom price range',
        })}
        onClick={handleOptionClick}
      >
        <FlexBox UNSAFE_className="option-label" alignItems="center" gap="8px">
          <button
            className={classnames('select-range-radio-btn', {
              checked: isOptionSelected === option.value,
            })}
          >
            {isOptionSelected === option.value && <div className="select-range-radio-btn-inner" />}
          </button>
          <label htmlFor={option.label}>{option.label}</label>
        </FlexBox>
        {isOptionSelected === 'Custom price range' && isCustomRange && (
          <FlexBox
            flexDirection="column"
            gap="12px"
            alignItems="flex-end"
            UNSAFE_className="custom-ranges"
          >
            <FlexBox
              UNSAFE_className="custom-input-wrapper"
              justifyContent="space-between"
              gap="8px"
              alignSelf="center"
            >
              <FlexBox flexDirection="column" alignItems="flex-start">
                Min
                <div className="input-wrapper">
                  <span className="dollar-sign">$</span>
                  <input
                    name="minRange"
                    className={classnames('min-max-input', { 'err-input': error })}
                    value={customMin ? `${customMin}` : ''}
                    onChange={e => {
                      cancelDefaultActions(e);
                      handleCustomInputChange(e.target.value, 'min');
                    }}
                    onClick={e => {
                      cancelDefaultActions(e);
                    }}
                  />
                </div>
              </FlexBox>
              <FlexBox flexDirection="column" alignItems="flex-start">
                Max
                <div className="input-wrapper">
                  <span className="dollar-sign">$</span>
                  <input
                    name="maxRange"
                    className={classnames('min-max-input', { 'err-input': error })}
                    value={customMax ? `${customMax}` : ''}
                    onChange={e => {
                      cancelDefaultActions(e);
                      handleCustomInputChange(e.target.value, 'max');
                    }}
                    onClick={e => {
                      cancelDefaultActions(e);
                    }}
                  />
                </div>
              </FlexBox>
            </FlexBox>
            {error && <p className="err-msg">{error}</p>}
            <div className="divider" />
            <Button kind="link" weight="400" onClick={handleApply}>
              Apply
            </Button>
          </FlexBox>
        )}
      </button>
    );
  };

  return (
    <div className="FindYourProspectFilters__priceFilterConatiner">
      <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
        <Text size="m" tag="div" on="grey-500" UNSAFE_className="title">
          Price Range
        </Text>
        <div className="title-divider" />
      </div>
      <br />
      <div className="FindYourProspectFilters__priceFilter" style={{ marginBottom: '20px' }}>
        <Dropdown
          ref={dropdownRef}
          value={isOptionSelected || selectedRange}
          onChange={e => {
            if (e.target.value === 'Custom price range') {
              cancelDefaultActions(e);
            }
            onChange(e, e.target.value);
          }}
          valueTemplate={(option, props) => {
            if (!option) return props.placeholder;
            if (option.value === 'Custom price range') {
              const findPriceInPriceList = arrOfPrice.find(opt => opt.value === customRange);
              const value =
                !findPriceInPriceList && (customMax || customMin)
                  ? formatPriceRange(customRange)
                  : option.value;
              return value ?? props.placeholder;
            }
            return option.value === 'Any' ? option.label : formatPriceRange(option.value);
          }}
          options={arrOfPrice}
          optionLabel="label"
          placeholder="Select price range"
          itemTemplate={itemTemplate}
          panelClassName="range-select-panel"
          className="range-select"
        />
      </div>
      <hr />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Button
          kind="default"
          size="l"
          UNSAFE_className="SellYourListingFaster__modalCancel"
          weight="bold"
          onClick={() => onClickCancelOrClear('Cancel')}
        >
          Cancel
        </Button>
        <Button
          kind="primary"
          UNSAFE_className="SellYourListingFaster__modalSave"
          size="l"
          weight="bold"
          onClick={onSaveChanges}
          disabled={isDisabled}
        >
          Save Changes
        </Button>
      </div>
    </div>
  );
};
